// extracted by mini-css-extract-plugin
export default {"noticeWrap":"Notice_noticeWrap__oSwqD"};